import en from './en'
import fr from './fr'

export default defineI18nConfig(() => ({
  locales: [
    {
      code: 'fr',
      iso: 'fr-FR',
      name: 'Français',
    },
  ],
  defaultLocale: 'fr',
  legacy: false,
  locale: 'fr',
  messages: {
    fr,
    en,
  },
}))
